"use client";

import { m, useInView } from "framer-motion";
import { MarqueeContent } from "../header/serviceMenuItem";
import { Marquee } from "@/app/components/marquee";
import TransitionLink from "../transitionLink";
import { useRef } from "react";
import { dividerVariants, variantsText } from "../variants";
import SectionHeader from "../sectionHeader";

interface Props {
  data?: any;
}

export default function ServicesSection({ data }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
  });
  return (
    <m.section
      ref={ref}
      transition={{ staggerChildren: 0.05, delayChildren: 0.2 }}
      initial="initial"
      animate={isInView ? "animate" : "initial"}
      className={`flex flex-col items-start gap-8 section !px-0 ${data?.darkerBackground ? "bg-neutral-200/50" : ""}`}
    >
      {/* Heading area - left aligned, container width */}
      <div className="container mx-auto">
        <SectionHeader
          title={data?.title}
          headline={data?.headline}
          text={data?.text}
        />
      </div>

      {/* Services list */}
      <div className="w-full flex flex-col">
        <m.div variants={dividerVariants} className={`w-full h-px bg-black`} />
        {data?.services?.map((item: any, index: number) => (
          <TransitionLink
            href={`/${item.page?.slug?.current}`}
            key={index}
            classes={`block relative h1 uppercase text-center w-full flex flex-col justify-center group overflow-hidden h-[11vw] xl:h-28`}
          >
            <div className="overflow-hidden flex items-center justify-center">
              <m.span
                variants={variantsText}
                className="pb-[1vw] lg:pb-3 gap-8 flex justify-center items-center whitespace-nowrap"
              >
                {item.title}
              </m.span>
            </div>

            <div className="w-full overflow-hidden bg-primary h-0 group-hover:h-full bottom-0 group-hover:top-[0] group-hover:bottom-[auto] gap-8 absolute transition-all duration-200 group-hover:delay-100 flex justify-center items-end group-hover:items-start">
              <Marquee
                direction="left"
                className="w-full h-[11vw] xl:h-28 flex items-center whitespace-nowrap gap-8"
                innerClassName="flex items-center gap-8 text-black"
              >
                <MarqueeContent subItem={item} />
                <MarqueeContent subItem={item} />
                <MarqueeContent subItem={item} />
              </Marquee>
            </div>
            <m.div
              variants={dividerVariants}
              className={`w-full h-px bg-black absolute bottom-0`}
            />
          </TransitionLink>
        ))}
      </div>
    </m.section>
  );
}
